import { normalizeNextContactDate, persistedNextContactDate, persistedNextContactIsCompleted } from "./futureFollowUpGuard.mjs";

const TERMINAL = new Set(["venda", "fechou_venda", "sem_interesse", "seminteresse", "desqualificado"]);
export function isOngoingProspect(record) {
  if (!record || record.deleted === true || record.excluido === true || record.desqualificado === true) return false;
  const stage = String(record.stage || record._crm_estagio || "").trim().toLowerCase();
  if (TERMINAL.has(stage)) return false;
  return ["respondeu", "interesse", "tem_interesse"].includes(stage)
    || Boolean(persistedNextContactDate(record) && !persistedNextContactIsCompleted(record));
}

export function prospectsForViewer(records, user, consultantStoreId = () => null) {
  return (records || []).filter(record => {
    if (!record || record.deleted === true || record.excluido === true) return false;
    if (user?.role === "admin") return true;
    const storeId = Number(record.storeId || consultantStoreId(record.consultantId));
    if (!(storeId > 0) || storeId !== Number(user?.storeId)) return false;
    if (user.role === "manager") return true;
    return user.role === "consultant" && Number(record.consultantId) === Number(user.id);
  });
}

// Operational cards stay in the columns regardless of the period, day or
// history search. A search can add matching closed/history cards, not remove
// ongoing work. Never bypass the authorized owner/store scope.
export function prospectBoardItems(records, { matchesDate = () => true, matchesOwner = () => true, query = "", matchesSearch = () => true } = {}) {
  return (records || []).filter(record => matchesOwner(record)
    && (isOngoingProspect(record) || (query.trim() ? matchesSearch(record) : matchesDate(record))));
}

export function prospectReturnsDue(records, today) {
  return (records || []).filter(record => {
    if (record?.stage === "contatado") return false;
    const due = persistedNextContactDate(record);
    return isOngoingProspect(record) && due && due <= today && !persistedNextContactIsCompleted(record);
  });
}

// Missing reminder rows must not hide a scheduled contact. These are display
// projections, never persisted tasks; opening resolves the exact source card.
export function mergeProspectReturns(reminders, records, today) {
  const result = (reminders || []).filter(reminder => !(
    ["followup", "prospeccao_followup"].includes(reminder.type)
    && records.some(record => record.stage === "contatado"
      && reminder.prospId != null
      && [record.id, record._firebaseKey].filter(id => id != null)
        .some(id => String(id) === String(reminder.prospId))
      && Number(reminder.consultantId) === Number(record.consultantId)
      && Number(reminder.storeId || record.storeId) === Number(record.storeId))
  ));
  for (const record of prospectReturnsDue(records, today)) {
    const cardId = record.id ?? record._firebaseKey;
    if (cardId == null) continue;
    const dueDate = persistedNextContactDate(record);
    const storeId = Number(record.storeId);
    const linked = result.some(reminder => reminder.status !== "done"
      && String(reminder.prospId) === String(cardId)
      && Number(reminder.storeId || record.storeId) === storeId
      && Number(reminder.consultantId) === Number(record.consultantId)
      && normalizeNextContactDate(reminder.dueDate) === dueDate);
    if (linked) continue;
    result.push({
      id:`prospect-return:${storeId}:${cardId}:${dueDate}`, prospId:cardId,
      storeId, consultantId:Number(record.consultantId), dueDate, status:"pending",
      clientName:record.name || record.nome || "Cliente", clientPhone:record.phone || record.telefone,
      text:"Retorno de Prospecção", projectedProspectReturn:true,
    });
  }
  return result;
}
